import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { GroupedView } from '@bibliocommons/deprecated-base-icons';
import { DefaultButton } from '@bibliocommons/deprecated-base-buttons';
import cn from 'classnames';

const GroupedSearchButton = ({ currentView, toggleListView, className }) => {
  const isActive = currentView === 'grouped' ? 'active' : '';
  const toggleView = () => toggleListView('grouped');
  const btnClasses = cn('cp-group-search-button', className, {
    active: currentView === 'grouped'
  });

  return (
    <FormattedMessage id="grouped_view" values={{ isActive: isActive ? 'yes' : 'no' }}>
      {message => (
        <DefaultButton
          data-test-id="grouped-search-button"
          className={btnClasses}
          flat
          handleClick={toggleView}
          title={message}
        >
          <GroupedView />
          <ScreenReaderMessage>{message}</ScreenReaderMessage>
        </DefaultButton>
      )}
    </FormattedMessage>
  );
};

GroupedSearchButton.propTypes = {
  className: PropTypes.string,
  currentView: PropTypes.string,
  toggleListView: PropTypes.func.isRequired
};

export default GroupedSearchButton;
